import { STORAGE_TOKEN_NAME } from '@/config/constants'

export const tokenToJSON = () => {
  const token = localStorage.getItem(STORAGE_TOKEN_NAME)
  if (!token) {
    return
  }

  const tokeURL = token.split('.')[1]

  return JSON.parse(atob(tokeURL))
}

export const mustBeGuestAuthenticate = () => {
  const token = localStorage.getItem(STORAGE_TOKEN_NAME)
  if (!token) {
    return true
  }

  const currentDate = Math.floor(new Date().getTime() / 1000.0)
  const tokenData = tokenToJSON()

  return currentDate >= tokenData.exp
}
